import api from './axios';
import { ApiResponse } from '../types';

export type Player = {
  id: string;
  name: string;
  phone: string;
  email?: string;
  dob?: string;
  division?: string;
  district_code?: string;
  district_name?: string;
  upazilla?: string;
  playing_role?: string;
  batting_style?: string;
  bowling_style?: string;
  status: string;
  created_at?: string;
  payment_submitted_at?: string;
  payment_method?: string;
  transaction_id?: string;
  jersey_size?: string;
  cricheroes_profile_link?: string;
  player_id?: string;
  playerId?: string;
};

export type PlayerFilters = {
  status?: string[];
  search?: string;
  district?: string;
  limit?: number;
  offset?: number;
};

export type UpdatePlayerStatusPayload = {
  status: 'APPROVED' | 'DECLINED' | 'PENDING_APPROVAL';
};

export const getAdminPlayers = async (filters?: PlayerFilters) => {
  const response = await api.get<ApiResponse<Player[]>>('/api/v1/admin/players', { params: filters });
  return response.data;
};

export const getAdminPlayer = async (playerId: string) => {
  const response = await api.get<ApiResponse<Player>>(`/api/v1/admin/players/${playerId}`);
  return response.data;
};

export const updatePlayerStatus = async (playerId: string, payload: UpdatePlayerStatusPayload) => {
  const response = await api.put<ApiResponse<Player>>(`/api/v1/admin/players/${playerId}/status`, payload);
  return response.data;
};

export const updatePlayerInfo = async (playerId: string, payload: Partial<Player> | FormData) => {
  const headers = payload instanceof FormData
    ? { 'Content-Type': 'multipart/form-data' }
    : { 'Content-Type': 'application/json' };
  
  const response = await api.put<ApiResponse<Player>>(`/api/v1/admin/players/${playerId}`, payload, { headers });
  return response.data;
};

export const deletePlayer = async (playerId: string) => {
  const response = await api.delete<ApiResponse<Player>>(`/api/v1/admin/players/${playerId}`);
  return response.data;
};


